import { Injectable } from '@angular/core';

import { ROUTING_PATH } from '@shared/constants/routingPath';

import {
  TrialInsightsPatientCostKey,
  TrialInsightsTableModel,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
} from '../../models/trial-insights-table.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsClinicalPatientCostTableService implements TrialInsightsTableModel {
  route = ROUTING_PATH.INVESTIGATOR.INDEX;
  subRoute = `${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.INDEX}`;

  createTable = (
    selectedKey: TrialInsightsPatientCostKey = TrialInsightsPatientCostKey.SITE,
    rowData: TrialInsightsTableRowData[] = []
  ): TrialInsightsTableOptions => {
    return {
      buttons: {
        data: [
          { key: 'site', value: 'Avg. Patient Cost/Site' },
          { key: 'group', value: 'Avg. Patient Cost/Group' },
        ],
        defaultButtonKey: selectedKey,
        display: true,
      },
      header: {
        data: [
          { buttonKey: 'site', leftValue: 'Site', rightValue: 'Avg. Patient Cost' },
          { buttonKey: 'group', leftValue: 'Group', rightValue: 'Avg. Patient Cost' },
        ],
        display: true,
      },
      link: {
        display: true,
        url: `/${this.route}/${this.subRoute}`,
        value: 'See All Sites',
      },
      rowData: {
        compact: false,
        data: rowData,
      },
    };
  };
}
